/** xuxx
 * 功能：渲染店铺名称
 * 参数：gridColumns:当前列数据，attrs:渲染列的属性字段名，link:是否支持点击详情事件，_this:当前被调用的vue实例
 */
export const renderShopName = function (gridColumns,attrs,link, _this) {
	let linkClass = "";
	if(link) {
		linkClass = "link"
	}
	if (gridColumns.prop == attrs) {
		_this.$set(gridColumns, "render", (h, params) => {
			let imgClass = params.row.platform?params.row.platform:params.row.platform_code;
			let imgSrc = "";
			try {
				imgSrc = require('@/assets/img/platform/pla_'+imgClass+'.png');
			} catch (err) {
				imgSrc = "";
			}
			if (params.row[attrs] && params.row[attrs] != "") {
				return h('div', {class: ["cell-shop","shop-img-"+ imgClass]},[
					h('span', {class: ["cell-span",linkClass],attrs:{title:params.row[params.column.prop]},
					on: {
						click: () => {
							let query = {
								shopId:params.row.id?params.row.id:'',
								dealerid:params.row.dealerid?params.row.dealerid:params.row.id?params.row.id:null
							}
							if(link)
							_this.linkDetail(query);
							return false;
						}
					  }},params.row[params.column.prop]),
					h('img', {class: ["img"],attrs: {src:imgSrc}}),
				]);
			}
		});
	}
}
/*xuxx
 *功能：渲染商品信息(链接新窗口打开)
 *参数：gridColumns:当前列数据，attrs:渲染列的属性字段名，link:url字段属性，_this:当前被调用的vue实例
 */
export const renderProductInfo = function (gridColumns,attrs,link, _this) {
	if (gridColumns.prop == attrs) {
		_this.$set(gridColumns, "render", (h, params) => {
			if (params.row[attrs] && params.row[attrs] != "") {
				let imgSrc = params.row.logopicurl;
				let href = params.row[link];
				return h('div', {class: ["cell-row"]},[
					imgSrc?h('img', {class: ["cell-img"],attrs: {src:imgSrc}}):'',
					h('el-link', {attrs:{title:params.row[params.column.prop]},props: {type: "primary",underline:false},
					on:{
						click($event){
							$event.cancelBubble = true;
							window.open(href)
						}
					}},params.row[params.column.prop]),
				]);
			}
		});
	}
}

/**
 * 渲染状态（启用，停用）
 */
export const renderState = function (gridColumns,attrs, _this) {
	if (gridColumns.prop == attrs) {
		_this.$set(gridColumns, "render", (h, params) => {
			if (params.row[attrs] && params.row[attrs] != "") {
				if (params.row[attrs] == 1) {
					return h('span', { class:["state active-state"] }, '启用');
				} else {
					return h('span', { class:["state inactive-state"] }, '停用');
				}
			}
		});
	}
}
/**
 * 操作时的弹框提示
 */
export const renderDialog = function(information,url,query,func,_this){
	const h = _this.$createElement;
	_this.$msgbox({
	  title: '提示',
	  customClass:'message-wrap',
	  message: h('div', {class:'message-box'}, [
		h('i', {class:'el-icon-warning'}),
		h('h5', {class:'title'},information.title),
		h('p', {class:'info'},[
		  h('span', {class:'info-ccc'},information.infoccc),
		  h('span', {class:'info-red'},information.infored)
		]),
	  ]),
	  showCancelButton: true,
	  cancelButtonText: '取消',
	  confirmButtonText: '确定',
	  beforeClose: (action, instance, done) => {
		if (action === 'confirm') {
      console.log(111111)
		  func(query,url);
		  done();
		} else {
      console.log(222222222)
		  done();
		}
	  }}).catch(action=>{})
  }

// 表格根据内容设置宽度
export var tableWidthAdaptation = function(_this){
	let rows = _this.$refs.dataTable.$el.childNodes[1].childNodes[2].childNodes[0].childNodes[1].rows;
	let arr = [];
	for (let i = 0; i < rows.length; i++) {
		for (let j = 0; j < rows[i].cells.length; j++) {
			let w =
			rows[i].cells[j].childNodes[0].childNodes[0].innerText.length>10?
			rows[i].cells[j].childNodes[0].childNodes[0].innerText.length*30:
			rows[i].cells[j].childNodes[0].childNodes[0].innerText.length*20
			if (!arr[j] || arr[j] < w) {
				arr[j] = columnWidth(w);
			}
		}
	}
	// 截取数组
	arr.splice(0,2)
	arr.splice(-1,1)
	let titleData = _this.gridColumns
	titleData.forEach((item,i)=> {
		item.width = arr[i]
	})
	_this.$set(_this.gridColumns,titleData)
  }

export const columnWidth = function(value, min = 80, max = 260) {
    // value = Number(value) + 12;
    if (value < min) {
		return min
	} else if (value > max) {
		return max
	} else {
		return value
	}
}
